module.exports = __webpack_public_path__ + "7126816a4a52525da2a693ee39497bb2.png";